/* index-fv
==================================================== */
const indexFvSwiperSelector = document.querySelector(".index-fv .swiper");

const indexFvSwiper = new Swiper(indexFvSwiperSelector, {
  loop: true,
  effect: "fade",
  slidesPerView: "auto",
  speed: 2500,
  allowTouchMove: false,
  autoplay: {
    delay: 4500,
    disableOnInteraction: false,
  },
});
